import { Injectable, Inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly isDark = signal(false);

  constructor(@Inject(DOCUMENT) private document: Document) {
    const saved = localStorage.getItem('theme');
    this.isDark.set(saved === 'dark');
    this.applyTheme();
  }

  toggleTheme(): void {
    this.isDark.update(value => !value);
    localStorage.setItem('theme', this.isDark() ? 'dark' : 'light');
    this.applyTheme();
  }

  private applyTheme(): void {
    const html = this.document.documentElement;
    if (this.isDark()) {
      html.classList.add('dark-mode');
      html.classList.add('p-dark');
    } else {
      html.classList.remove('dark-mode');
      html.classList.remove('p-dark');
    }
  }

  isDarkMode(): boolean {
    return this.isDark();
  }
}
